import { render, staticRenderFns } from "./SectionsTable.vue?vue&type=template&id=d7bce382"
import script from "./SectionsTable.vue?vue&type=script&lang=js"
export * from "./SectionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports